var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink5Hover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2837 30 30 23.2837 30 15C30 6.71631 23.2837 0 15 0C6.71631 0 0 6.71631 0 15C0 23.2837 6.71631 30 15 30ZM11.818 14.3834C12.4546 12.3302 12.6148 8.55248 9.21249 5C6.61966 7.91205 4.91435 12.7697 8.5007 15.7397C5.7716 17.3776 3.99996 20.0196 3.99996 23H26.0909C26.0909 20.0303 24.3038 17.3965 21.5687 15.7573C25.1832 12.789 23.4763 7.91782 20.8783 5C17.4653 8.56369 17.6373 12.354 18.2789 14.4028C17.2426 14.141 16.1431 14 15.0061 14C13.8975 14 12.8271 14.134 11.818 14.3834Z",
    fill: "url(#paint0_linear_1111_23572)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1111_23572",
    x1: -4.63576,
    y1: -12.8873,
    x2: 32.2715,
    y2: -11.6633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6346FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D752FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink5Hover);
export default __webpack_public_path__ + "static/media/link5-hover.9d7f54270086198ba47d33c556c0c857.svg";
export { ForwardRef as ReactComponent };